import { render, staticRenderFns } from "./AdminSwitch.vue?vue&type=template&id=1be2ab6a&"
import script from "./AdminSwitch.vue?vue&type=script&lang=ts&"
export * from "./AdminSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
